import cinema from '../assets/cinema.png';
import comedie from '../assets/comedie.png';
import divers from '../assets/divers.png';
import expositions from '../assets/expositions.png';
import theatre from '../assets/theatre.png';
import gastronomie from '../assets/gastronomie.png';
import litterature from '../assets/litterature.png';
import musique from '../assets/musique.png';
import famille from '../assets/famille.png';
import soirees from '../assets/soirees.png';
import sport from '../assets/sport.png';
import communaute from '../assets/communaute.png';
import gratuit from '../assets/gratuit.png';
import toutes from '../assets/toutes.png';

export const getIcon = (cat: string): string => {
    switch(cat) {
        case "cinema":
            return cinema;
        case "comedie":
            return comedie;
        case "divers":
            return divers;
        case "expositions":
            return expositions;
        case "theatre":
            return theatre;
        case "gastronomie":
            return gastronomie;
        case "litterature":
            return litterature;
        case "musique":
            return musique;
        case "famille":
            return famille;
        case "soirees":
            return soirees;
        case "sport":
            return sport;
        case "communaute":
            return communaute;
        case "gratuit":
            return gratuit;
        case "all":
            return toutes;
        default:
            return "";
        
    }
};